<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="采购入库通知单"
      :page="page"
      :show-query="true"
      :get-data-func="api.list"
      :show-checkbox="true"
      v-if="trendShow"
      urlHash="business/purchase/entrystore"
      :temp-params="tempParams"
      :queryParamsAppend="queryParamsAppend"
      @row-select="rowSelect"
      @onSelCheck="onSelCheck"
      @onAllCheck="onAllSelCheck"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="仓库" label-width="85px">
          <el-select filterable v-model="queryParamsAppend.WarehouseId" placeholder="请选择" clearable>
            <el-option v-for="item in WarehouseList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="业务类型" label-width="85px">
          <el-select v-model="queryParamsAppend.BusinessTypeId" clearable :disabled="isSelect">
            <el-option v-for="item in businessTypeList" :key="item.BusinessTypeId" :label="item.BusinessType" :value="item.BusinessTypeId"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
    <!-- 明细 -->
    <el-button v-if="show" type="primary" @click="onCustomTable" icon="el-icon-s-tools" style="margin: 30px 0 10px 10px"> 明细项 </el-button>
    <el-table ref="multipleTable" :row-key="row => row.Prop" :data="tableData" v-if="show" stripe border @selection-change="handleSelectionChange">
      <el-table-column v-if="is_listDialog" type="selection" width="55"> </el-table-column>
      <template v-for="(item, index) in tableColumns">
        <!-- 需判断是否有价格的权限  -->
        <template v-if="item.IsShow">
          <el-table-column
            :resizable="false"
            :key="`${item.Prop}-${index}`"
            :prop="item.Prop"
            v-if="shouldShowColumn(item)"
            :label="item.Label"
            :align="item.Align ?? 'left'"
            :min-width="item.Width"
            show-overflow-tooltip
          >
            <template slot-scope="{ row }">
              <span v-if="isNumericProperty(item.Prop)">
                {{ $commonJs.toThousands(row[item.Prop]) }}
              </span>
              <span v-else>
                {{ row[item.Prop] }}
              </span>
            </template>
          </el-table-column>
        </template>
      </template>
    </el-table>
    <customTableDialog ref="customTableDialog" @onSave="onSave" :initTableData="tableColumns" tableType="采购入库通知单明细" />
  </div>
</template>
<script>
import listMixin from '@/mixins/trend/list'
import list from '@/components/common/trendsTable/list'
import customTableDialog from '@/components/common/customTableDialog/customTableDialog'

export default {
  mixins: [listMixin],
  components: { list, customTableDialog },
  provide() {
    return {
      IsDefaultMonth: false
    }
  },
  props: {
    is_listDialog: {
      typeof: Boolean,
      default: false
    },
    isSelect: {
      typeof: Boolean,
      default: false
    }
    // canPrice: {
    //   typeof: Boolean,
    //   default: true,
    // }
  },
  data() {
    return {
      WarehouseList: [],
      warehouseApi: require('@/api/ba/warehouse').default,
      api: require('@/api/stock/stInDocTask').default,
      sourceTypeApi: require('@/api/ba/sourceType').default,
      businessTypeApi: require('@/api/ba/businessType').default,
      FieldSettingApi: require('@/api/sy/fieldSetting').default,
      trendShow: true,
      DocNo: '',
      TradeUnitId: null,
      TradeUnitName: '',
      tableData: [],
      subSelectList: [],
      queryParamsAppend: {
        BusinessTypeId: null
      },
      tempParams: {
        InType: 10
      },
      businessTypeList: [],
      tableColumns: [],
      show: false
    }
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice('/business/stock/purchaseinbound')
    }
  },
  created() {
    this.sourceTypeApi.info('采购入库通知单').then(res => {
      this.tempParams.InType = res.SourceTypeId
    })
  },
  activated() {
    // let SET_PurchaseReceipt = null;
    // if(localStorage.getItem('SET_PurchaseReceipt') === 'true'){
    //   SET_PurchaseReceipt = true
    // }else{
    //   SET_PurchaseReceipt = false;
    // }
    let WarehouseTypes = [1]
    // if(SET_PurchaseReceipt){
    //   WarehouseTypes = [1,3]
    // }else{
    //   WarehouseTypes = [1]
    // }
    this.warehouseApi.list({ Status: 1, WarehouseTypes: WarehouseTypes }).then(res => {
      if (res.Code === 0) {
        this.WarehouseList = res.Data
      }
    })
    this.getRouterInfo()
  },
  mounted() {
    this.getBusinessType()
    this.getTableColumns()
  },
  methods: {
    /** 价格权限的字段 */
    shouldShowColumn(item) {
      if (!item.IsShow) return false
      const priceProps = ['PurchasePrice', 'SalePrice', 'RetailPrice', 'QuotedPrice', 'Discount', 'TaxRate', 'Price', 'TaxPrice', 'Amount', 'TaxLimit', 'TaxAmount', 'DiscountAmount', 'Rate', 'Price']
      return (this.canPrice && priceProps.includes(item.Prop)) || !priceProps.includes(item.Prop)
    },
    /** 千位符格式化数字类型 */
    isNumericProperty(prop) {
      return ['PuQuantity', 'Amount', 'TaxAmount'].includes(prop)
    },
    async getTableColumns() {
      const res = await this.FieldSettingApi.list({ Type: '采购入库通知单明细' })
      this.tableColumns = []
      this.tableColumns = res.Data
    },
    onCustomTable() {
      this.$refs.customTableDialog.dialogVisible = true
    },
    onSave() {
      this.getTableColumns()
      this.$message.success('保存成功')
    },
    getBusinessType() {
      this.sourceTypeApi.list({}).then(res => {
        if (res.Code == 0) {
          this.SourceTypeIdArr = res.Data
          let params = '采购入库通知单'
          let index = this.SourceTypeIdArr.findIndex(item => item.SourceType == params)
          let SourceTypeId = this.SourceTypeIdArr[index].SourceTypeId
          this.businessTypeApi.getSourceTypeToBusinessType(SourceTypeId).then(res => {
            if (res.Code == 0) {
              this.businessTypeList = res.Data
            }
          })
        }
      })
    },
    getRouterInfo() {
      console.log('调用', this.$router.history.current.params)
      if (this.$router.history.current.params) {
        this.tempParams.SourceId = {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.SourceDocId
        }
        this.tempParams.SourceType = {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.SourceType
        }
        this.$refs.list.getData()
        this.params = {}
      }
    },
    rowSelect(row) {
      // this.show = true
      // let id = row.DocId
      // this.api.info(id).then(res => {
      //   if (res.Code === 0) {
      //     this.DocNo = res.Data.DocNo
      //     this.TradeUnitId = res.Data.TradeUnitId
      //     this.TradeUnitName = res.Data.TradeUnitName
      //     if (this.isSelect) {
      //       res.Data.Products.forEach(item => {
      //         item.Quantity = item.Quantity - (item.PuDocOccupyQuantity ?? 0)
      //         item.Amount = Number((item.Quantity * item.Price).toFixed(2))
      //       })
      //       let tList = res.Data.Products
      //       this.tableData = tList
      //     } else {
      //       this.tableData = res.Data.Products
      //     }
      //   }
      // })
    },
    onSelCheck(selection) {
      if (selection.length == 0) {
        this.tableData = []
        return
      }

      this.show = true
      this.tableData = []
      const Ids = selection.map(item => item.DocId)
      const o = {
        Ids: Ids
      }
      this.api.infos(o).then(res => {
        if (res.Code === 0) {
          this.DocNo = res.Data.DocNo
          this.TradeUnitId = res.Data.TradeUnitId
          this.TradeUnitName = res.Data.TradeUnitName

          if (this.isSelect) {
            res.Data.Products.forEach(item => {
              item.Quantity = item.Quantity - (item.PuDocOccupyQuantity ?? 0)
              item.Amount = Number((item.Quantity * item.Price).toFixed(2))
            })

            let tList = res.Data.Products
            this.tableData = tList
          } else {
            this.tableData = res.Data.Products
          }
        }
      })
    },
    onAllSelCheck(selection) {
      if (selection.length == 0) {
        this.tableData = []
        return
      }
      this.show = true
      const Ids = selection.map(item => item.DocId)
      const o = {
        Ids: Ids
      }
      this.api.infos(o).then(res => {
        if (res.Code === 0) {
          this.DocNo = res.Data.DocNo
          this.TradeUnitId = res.Data.TradeUnitId
          this.TradeUnitName = res.Data.TradeUnitName

          if (this.isSelect) {
            res.Data.forEach(item => {
              item.Quantity = item.Quantity - (item.PuDocOccupyQuantity ?? 0)
              item.Amount = Number((item.Quantity * item.Price).toFixed(2))
            })

            let tList = res.Data
            this.tableData = tList
          } else {
            this.tableData = res.Data
          }
        }
      })
    },
    handleSelectionChange(data) {
      this.subSelectList = data
    },
    toggleSelection(rows) {
      let $multipleTable = this.$refs.multipleTable
      if ($multipleTable) {
        if (rows) {
          rows.forEach(row => {
            $multipleTable.toggleRowSelection(row)
          })
        } else {
          $multipleTable.clearSelection()
        }
      }
    },
    clearSubSelectList() {
      this.toggleSelection()
    },
    clearList() {
      this.subSelectList = []
      this.show = false
    }
  }
}
</script>
